function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "icono_facebook",
  stroke: "#000000",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("g", {
  id: "1907128_facebook_logo_media_social_icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.2142857,0 L0.785714286,0 C0.351776268,0 0,0.351776268 0,0.785714286 L0,10.2142857 C0,10.6482237 0.351776268,11 0.785714286,11 L5.23809524,11 L5.23809524,6.80952381 L4.19047619,6.80952381 L4.19047619,5.23809524 L5.23809524,5.23809524 L5.23809524,4.19047619 C5.23809524,3.03330814 6.17616529,2.0952381 7.33333333,2.0952381 L8.9047619,2.0952381 L8.9047619,3.66666667 L7.33333333,3.66666667 C7.04404132,3.66666667 6.80952381,3.90118418 6.80952381,4.19047619 L6.80952381,5.23809524 L8.9047619,5.23809524 L8.64285714,6.80952381 L6.80952381,6.80952381 L6.80952381,11 L10.2142857,11 C10.6482237,11 11,10.6482237 11,10.2142857 L11,0.785714286 C11,0.351776268 10.6482237,0 10.2142857,0 Z",
  id: "_Path_"
}))));

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "11px",
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono_facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.cdf5dc18.svg";
export { ForwardRef as ReactComponent };